import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const SendIcon: FC<IconProps> = (props) => (
  <SVGIcon {...props} fill="none" viewBox="0 0 25 24">
    <path
      d="M18.8005 4.10588C18.9206 4.07097 19.1469 4.0114 19.4003 4.0634L19.5109 4.09343L19.6332 4.14177C19.8703 4.2532 20.0608 4.44452 20.1723 4.68156L20.2213 4.80387L20.2506 4.91374C20.3029 5.16744 20.2438 5.39408 20.2089 5.51432C20.1633 5.67114 20.0887 5.8593 20.0155 6.04679L15.0732 18.7126C14.9914 18.922 14.9123 19.1269 14.8351 19.2831C14.7712 19.4125 14.6285 19.6872 14.3334 19.8405C14.008 20.0094 13.6207 20.0091 13.2956 19.8398C13.0005 19.6861 12.8584 19.411 12.7946 19.2817C12.7176 19.1254 12.6388 18.9206 12.5573 18.7111L10.6098 13.7043L5.60294 11.7575C5.39357 11.6761 5.18934 11.5972 5.03312 11.5202C4.90378 11.4564 4.62873 11.3142 4.47501 11.0192C4.3055 10.6939 4.30515 10.3062 4.47428 9.98063C4.62762 9.68559 4.90237 9.54358 5.03165 9.47966C5.18779 9.40245 5.39211 9.32332 5.60148 9.24162L18.2672 4.2985C18.4548 4.22531 18.6436 4.15144 18.8005 4.10588ZM12.0658 13.3088L13.8156 17.808L17.8153 7.55925L12.0658 13.3088ZM6.50602 10.4985L11.0046 12.2482L16.7533 6.49943L6.50602 10.4985Z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default SendIcon;
